const survey = new Survey.Model(json);
const lang = Shopify.locale;

themeJson.completeText = lang==="lt"?"Siųsti":"Submit";
survey.locale = lang;
survey.applyTheme(themeJson);

survey.onComplete.add((sender, options) => {
  
  let data = sender.data;
  
  const url= "https://webhook.site/whs-savaip-contact-us"; 
  
  document.querySelector(".sd-completedpage").innerHTML = "Submitting..";

  async function postJSON( u, d) {
    try {
      const response = await fetch(u, {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(d),
      });
  
      const result = await response;
      
      return result.status;
      
    } catch (error) {
      return error;
    }
  }
  
  postJSON( url, data ).then((res) => {
    if (res === 200 )
    {
      let subscribe_to_list = __mp_obj;
      subscribe_to_list.EVENT = "QRCODE_click";
      subscribe_to_list.EMAIL = data.email;
      fidPromise( "Subscribed to List", subscribe_to_list );
      document.querySelector(".sd-completedpage").innerHTML = "Your request has been successful!";
      //console.log( "OK: ",res); // JSON data parsed by `data.json()` call
    }
    else
    { 
      document.querySelector(".sd-completedpage").innerHTML = "Submission did not suceeded! Try again later.";
      console.log( "Err: ", res); // JSON data parsed by `data.json()` call
    }
  });
  
/*
  try
  {
    //alert( JSON.stringify(submit_data, null, 3));
    //console.log(JSON.stringify(sender.data, null, 3));
    //const url = "https://hook.eu1.make.com/9j6oe2k8o2l5nxggl51rgvbhr5af9l0u"; 

    let xhr = new XMLHttpRequest();
    xhr.open( "POST", url, true );
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*" );
    
    let data = JSON.stringify(submit_data);
    xhr.onload = () => { 
      alert( xhr.responseText );
      if( xhr.responseText === "Accepted" )
        document.querySelector(".sd-completedpage").innerHTML = "Thank you for contacting us! Your request has been successfully submitted and is being processed by the SavaipSkin team.";
      else
        document.querySelector(".sd-completedpage").innerHTML = "Submission did not suceeded please write us directly email to info@savaipskin.com";
    };
    console.log( xhr.responseText );
    xhr.send(data);
  }
  catch(err)
  {
    console.log("Req err:" + err); 
  }
*/

});

//Survey.surveyLocalization.locales["en"].completingSurvey = "Thank you for contacting us!";
//Survey.surveyLocalization.locales["lt"].completingSurvey = "Jūsų paklausimas sėkmingai išsiųstas!";

$("#surveyElement").Survey({ model: survey });